// Reusable confirm dialog for "Done reading?" / "Are you sure you want to
// stop?" moments throughout the session flow (Section 10).

export default function ConfirmationModal({ open, title, message, confirmLabel, cancelLabel, onConfirm, onCancel, danger = false }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 px-5 pb-8 sm:pb-0">
      <div className="w-full max-w-sm rounded-xl2 border border-hairline bg-panel p-6">
        <h2 className="font-display text-xl mb-2">{title}</h2>
        {message && <p className="text-dim mb-6">{message}</p>}
        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={onConfirm}
            className={danger ? 'btn-stop min-h-touch w-full' : 'btn-primary'}
          >
            {confirmLabel}
          </button>
          <button type="button" onClick={onCancel} className="btn-secondary">
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
